import { render, staticRenderFns } from "./LabsIndexFilter.vue?vue&type=template&id=2873ffe0&scoped=true&"
import script from "./LabsIndexFilter.vue?vue&type=script&lang=js&"
export * from "./LabsIndexFilter.vue?vue&type=script&lang=js&"
import style0 from "./LabsIndexFilter.vue?vue&type=style&index=0&id=2873ffe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2873ffe0",
  null
  
)

export default component.exports